/** Тип балансовых операций (приход/расход) */
export enum BalanceDocType {
    /** Приход */
    Arrival = "arrival",
    /** Расход */
    Leave = "leave",
}
